import React, {createContext, ReactNode} from 'react'
import {LOCAL_STORAGE} from '@utils/Const'
import {appInit} from '@redux/app/appSlice'
import {initTracking} from '@utils'

// Define an interface for your context value
interface AuthContextType {
  onLogin: (data1: any) => void
  onLogout: () => void
}

// Use the interface to define the type of the context
const AuthContext = createContext<AuthContextType | null>(null)

interface AuthProviderProps {
  children: ReactNode // Use ReactNode for children type
}

const AuthProvider = ({children}: AuthProviderProps) => {
  const handleLogin = async (data1: any) => {
    localStorage.setItem(
      LOCAL_STORAGE.ACCESS_TOKEN,
      data1?.data?.data?.access_token,
    )
    localStorage.setItem(
      LOCAL_STORAGE.REFRESH_TOKEN,
      data1?.data?.data?.refresh_token,
    )
    localStorage.setItem(LOCAL_STORAGE.USER_ID, data1?.data?.data?.user_id)
    initTracking(data1?.data?.data?.user_id)
  }

  const handleLogout = async () => {
    // Implementation of logout logic
    localStorage.clear()
  }

  // This object now conforms to the AuthContextType interface
  const value = {
    onLogin: handleLogin,
    onLogout: handleLogout,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export {AuthProvider, AuthContext}
